import { Url } from '../shared/Url';
import Post from '../shared/Post';

sessionStorage.setItem('requestUserName3', false)
export const consultaUsuario = (respuesta) => {
    if (sessionStorage.getItem('requestUserName3') === true) return null
    sessionStorage.setItem('requestUserName3', true)

    let leerCookie = (nombre) => {
        let lista = document.cookie.split(";");
        let micookie;
        let igual;
        let valor;
        for (let i in lista) {
          let busca = lista[i].search(nombre);
          if (busca > -1) {micookie=lista[i]}
        }
        
        if (micookie === undefined) return null;
        
        igual = micookie.indexOf("=");
        valor = micookie.substring(igual + 1);
        return valor;
      }

    let valor = leerCookie("S_ID")
    let valor2 = leerCookie("U_ID");
    
    /* let valor = "";
    let valor2 = "";
    let lista = document.cookie.split(";");
    for (let i = 0; i <= lista.length; i++){
        if (lista[i] !== undefined) {
            let item = lista[i].split("=");
            if (item[0] === " S_ID"){
                valor = item[1];
            }else if (item[0] === " U_ID"){
              valor2 = item[1];
            }
        }
    } */

    let Content = {
        sId: valor,
        uId: valor2,
    }

    Post(`${Url}userName`, Content, (resp) => {
        sessionStorage.setItem('requestUserName3', false)
        let data = JSON.parse(resp);
        respuesta(data.user_001);
    });
}

export const cookieData = (respuesta) => {
    let leerCookie = (nombre) => {
        let lista = document.cookie.split(";");
        let micookie;
        let igual;
        let valor;
        for (let i in lista) {
          let busca = lista[i].search(nombre);
          if (busca > -1) {micookie=lista[i]}
        }
        
        if (micookie === undefined) return null;
        
        igual = micookie.indexOf("=");
        valor = micookie.substring(igual + 1);
        return valor;
      }

    let valor = leerCookie("S_ID")
    let valor2 = leerCookie("U_ID");

    respuesta ([valor, valor2])
}


// WEBPACK FOOTER //
// ./src/funciones/ConsultaUser.jsx